// removed by extract-text-webpack-plugin
module.exports = {"logo-wrapper":"Logo__logo-wrapper","logoWrapper":"Logo__logo-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Logo/Logo.scss
// module id = 1488
// module chunks = 8